import './BannerSimulacaoPhone.css';
import logo from '../../../imgs/logo-eqg-white.svg'

function BannerSimulacaoPhone() {
    return (
        <div className='container-phones-mobile-simulacao'>
            <img className='logo2' alt='logo eu quero grana' src={logo} />
            <div className='textosCabecalho'>
                <h2>Passo 3 de 6</h2>
                <h1>Simulação</h1>
            </div>
        
        </div>
    );
}

export default BannerSimulacaoPhone;